import { Link } from 'react-router-dom';
import { Search, ChevronDown } from 'lucide-react';
import { NotificationCenter } from './NotificationCenter';

/**
 * 顶部全局栏：Logo + 空间切换 + 搜索 + 通知 + 头像
 */
export function TopBar() {
  return (
    <header className="flex h-14 items-center justify-between border-b border-border/60 bg-bg-surface/80 px-4 backdrop-blur-xl supports-[backdrop-filter]:bg-bg-surface/70">
      <div className="flex items-center gap-3">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-accent text-xs font-bold text-text-inverse shadow-sm">
            C
          </div>
          <span className="text-[15px] font-semibold tracking-tight">CoMind</span>
        </Link>
        <button
          type="button"
          className="flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-sm text-text-secondary hover:bg-bg-subtle transition-all duration-fast"
          aria-label="切换工作空间"
        >
          我的空间
          <ChevronDown className="h-3.5 w-3.5" />
        </button>
      </div>

      <div className="flex items-center gap-1.5">
        <button
          type="button"
          className="flex h-9 w-9 items-center justify-center rounded-lg text-text-secondary hover:bg-bg-subtle transition-all duration-fast"
          aria-label="搜索（⌘K）"
        >
          <Search className="h-4 w-4" />
        </button>
        <NotificationCenter />
        <div className="ml-1 flex h-8 w-8 items-center justify-center rounded-lg bg-accent/10 text-sm font-semibold text-accent ring-1 ring-accent/20" aria-label="用户菜单">
          我
        </div>
      </div>
    </header>
  );
}
